export default "__VITE_ASSET__DlwiZ33y__"